const API_URL = 'https://api-pedidos.krivosistemas.com.br/api'; // Altere para a URL da sua API

export { API_URL }; 